/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateFeatureRequest,
  UpdateFeatureRequest,
  UpdateReleaseStateRequest,
} from '../models/index';
import {
    CreateFeatureRequestFromJSON,
    CreateFeatureRequestToJSON,
    UpdateFeatureRequestFromJSON,
    UpdateFeatureRequestToJSON,
    UpdateReleaseStateRequestFromJSON,
    UpdateReleaseStateRequestToJSON,
} from '../models/index';

export interface CreateFeatureOperationRequest {
    createFeatureRequest: CreateFeatureRequest;
}

export interface GetFeatureRequest {
    id: string;
}

export interface UpdateFeatureOperationRequest {
    id: string;
    updateFeatureRequest: UpdateFeatureRequest;
}

export interface UpdateReleaseStateOperationRequest {
    id: string;
    updateReleaseStateRequest: UpdateReleaseStateRequest;
}

/**
 * FeatureAdminApi - interface
 * 
 * @export
 * @interface FeatureAdminApiInterface
 */
export interface FeatureAdminApiInterface {
    /**
     * 
     * @summary Create feature (admin)
     * @param {CreateFeatureRequest} createFeatureRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureAdminApiInterface
     */
    createFeatureRaw(requestParameters: CreateFeatureOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Create feature (admin)
     */
    createFeature(requestParameters: CreateFeatureOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Get feature by ID (admin)
     * @param {string} id Feature entity ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureAdminApiInterface
     */
    getFeatureRaw(requestParameters: GetFeatureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get feature by ID (admin)
     */
    getFeature(requestParameters: GetFeatureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns the full feature catalog including inactive
     * @summary List all features (admin)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureAdminApiInterface
     */
    listFeaturesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns the full feature catalog including inactive
     * List all features (admin)
     */
    listFeatures(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Update feature (admin)
     * @param {string} id Feature entity ID
     * @param {UpdateFeatureRequest} updateFeatureRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureAdminApiInterface
     */
    updateFeatureRaw(requestParameters: UpdateFeatureOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Update feature (admin)
     */
    updateFeature(requestParameters: UpdateFeatureOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Update feature release state (admin)
     * @param {string} id Feature entity ID
     * @param {UpdateReleaseStateRequest} updateReleaseStateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureAdminApiInterface
     */
    updateReleaseStateRaw(requestParameters: UpdateReleaseStateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Update feature release state (admin)
     */
    updateReleaseState(requestParameters: UpdateReleaseStateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class FeatureAdminApi extends runtime.BaseAPI implements FeatureAdminApiInterface {

    /**
     * Create feature (admin)
     */
    async createFeatureRaw(requestParameters: CreateFeatureOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['createFeatureRequest'] == null) {
            throw new runtime.RequiredError(
                'createFeatureRequest',
                'Required parameter "createFeatureRequest" was null or undefined when calling createFeature().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/admin/features`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateFeatureRequestToJSON(requestParameters['createFeatureRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Create feature (admin)
     */
    async createFeature(requestParameters: CreateFeatureOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.createFeatureRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get feature by ID (admin)
     */
    async getFeatureRaw(requestParameters: GetFeatureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getFeature().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/admin/features/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get feature by ID (admin)
     */
    async getFeature(requestParameters: GetFeatureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getFeatureRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the full feature catalog including inactive
     * List all features (admin)
     */
    async listFeaturesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/admin/features`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns the full feature catalog including inactive
     * List all features (admin)
     */
    async listFeatures(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listFeaturesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update feature (admin)
     */
    async updateFeatureRaw(requestParameters: UpdateFeatureOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateFeature().'
            );
        }

        if (requestParameters['updateFeatureRequest'] == null) {
            throw new runtime.RequiredError(
                'updateFeatureRequest',
                'Required parameter "updateFeatureRequest" was null or undefined when calling updateFeature().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/admin/features/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFeatureRequestToJSON(requestParameters['updateFeatureRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Update feature (admin)
     */
    async updateFeature(requestParameters: UpdateFeatureOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.updateFeatureRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update feature release state (admin)
     */
    async updateReleaseStateRaw(requestParameters: UpdateReleaseStateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateReleaseState().'
            );
        }

        if (requestParameters['updateReleaseStateRequest'] == null) {
            throw new runtime.RequiredError(
                'updateReleaseStateRequest',
                'Required parameter "updateReleaseStateRequest" was null or undefined when calling updateReleaseState().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/admin/features/{id}/release-state`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateReleaseStateRequestToJSON(requestParameters['updateReleaseStateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Update feature release state (admin)
     */
    async updateReleaseState(requestParameters: UpdateReleaseStateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.updateReleaseStateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
